import { OperationPage } from "./OperationPage";

const Operation = () => {
	return <OperationPage />;
};
export default Operation;
